/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// O hub do legado (ConciliationOptions.tsx) só tem o card Dataprev: leva direto à lista.
export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/')({
  beforeLoad: () => {
    throw redirect({ to: '/gestao-carteira/conciliacao/dataprev', replace: true });
  },
});
